(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["findly-color-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('findly-color-picker')) {
    customElements.define('findly-color-picker', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._opt = this.dataset.optionName;
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this.addEventListener('click', this._onClick);
        this._section = this.closest('.shopify-section') || document;
        this._section.addEventListener('change', this._onChange);
      }
      disconnectedCallback() {
        this._ready = false;
        this.removeEventListener('click', this._onClick);
        if (this._section) this._section.removeEventListener('change', this._onChange);
      }
      _sel(v) {
        this.querySelectorAll('.findly-colors__tile').forEach((t) => {
          const on = t.dataset.value === v;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const cur = this.querySelector('[data-findly-color-current]');
        if (cur) cur.textContent = v;
      }
      _onClick(e) {
        const t = e.target.closest('.findly-colors__tile');
        if (!t) return;
        const v = t.dataset.value;
        this._sel(v);
        const inputs = this._section.querySelectorAll('variant-picker input[type="radio"]');
        for (const i of inputs) {
          if (i.dataset.optionName === this._opt && i.value === v) {
            if (!i.checked) i.click();
            return;
          }
        }
        const s = this._section.querySelector('variant-picker select[name="options[' + this._opt + ']"]');
        if (s) {
          s.value = v;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      _onChange(e) {
        const i = e.target;
        if (i && i.dataset && i.dataset.optionName === this._opt && i.checked) this._sel(i.value);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
